export default __webpack_public_path__ + "static/media/arrow-down-outline.4275d385.svg";